import React, { useState } from 'react';
import { useLanguage } from '@/state/language/LanguageProvider';
import { toast } from 'react-hot-toast';
import { ClipboardDocumentIcon } from '@heroicons/react/24/outline';
import { AE_BTN_SECONDARY } from './layout/aeTheme';

interface CopyLinkButtonProps {
  url: string;
  className?: string;
}

/** Copy a URL to clipboard with toast feedback. */
export const CopyLinkButton: React.FC<CopyLinkButtonProps> = ({ url, className = '' }) => {
  const { t } = useLanguage();
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      toast.success(t('assessmentEngine.share.copy'));
      setTimeout(() => setCopied(false), 2000);
    } catch {
      toast.error(t('assessmentEngine.share.copyFailed'));
    }
  };

  return (
    <button type="button" onClick={handleCopy} className={`${AE_BTN_SECONDARY} ${className}`}>
      <ClipboardDocumentIcon className="h-4 w-4" />
      {copied
        ? t('assessmentEngine.share.copied')
        : t('assessmentEngine.share.copy')}
    </button>
  );
};
